import { Component, OnInit, ViewChild } from '@angular/core';

import { RestapiService } from '../../services/restapi.service';
import { RoutingService } from '../../services/routing.service';
import { UserService } from '../../services/user.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-game-create',
  templateUrl: './game-create.component.html',
  styleUrls: ['./game-create.component.scss']
})
export class GameCreateComponent implements OnInit {

  constructor(
    public api: RestapiService,
    public route: RoutingService,
    public user: UserService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }

}
